import { RESELLER_GROUP } from 'permissions/userGroups';
import {
  LOGIN_SUCCESS,
  LOGIN_PENDING,
  LOGIN_FAILED,
  LOGOUT,
} from '../actions/types';

const login = (state = { loggedIn: false }, action) => {
  switch (action.type) {
    case LOGIN_PENDING:
      return {
        ...state,
        status: LOGIN_PENDING,
      };
    case LOGIN_SUCCESS:
      return {
        user: action.response,
        loggedIn: true,
      };
    case LOGIN_FAILED:
      return {
        user: null,
        loggedIn: false,
        status: LOGIN_FAILED,
      };
    case LOGOUT:
      return {
        user: null,
        loggedIn: false,
        status: LOGOUT,
      };
    default:
      return state;
  }
};
export default login;

export const getIsLoggedIn = (state) => state.loggedIn && Boolean(state.user);
export const getLogin = (state) => state.user || {};

export const getIsLoginPendingStatus = (state) =>
  state.status === LOGIN_PENDING;
export const getIsAdmin = (state) =>
  state.user && state.user.acl_group_name === 'ADMIN';
export const getIsAdminOrManager = (state) =>
  state.user &&
  (state.user.acl_group_name === 'ADMIN' ||
    state.user.acl_group_name === 'MANAGER');
export const getIncludedInGroups = (state, groups = []) =>
  state.user && groups.includes(state.user.acl_group_name);
export const getIsResellerGroup = (state) => {
  return state.user && RESELLER_GROUP.includes(state.user.acl_group_name);
};
